import styled from "styled-components";

export const Container = styled.div`
  background: #5e2da6;
  height: 10vh;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  color: white;
  font-size: 40px;
  text-align: center;
  font-weight: 400;
  font-family: 'Dongle', sans-serif;
`;